module.exports = __webpack_public_path__ + "mobilya2.jpeg?3b9e15f8b8dedeeee203708c587c2f04";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/mobilya2.jpeg
// module id = 319
// module chunks = 0